import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Widths extends Component {
  render() {
    return (
      <EntityList apiRoute='api/widths' title='Remorque - Largeurs' editTitle='Largeur' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Valeur', Column: 'Value'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Widths;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/widths.js
 **/